import {
  yellow
} from "./chunk-JUEOCLA3.mjs";
import {
  zinc
} from "./chunk-3LKKH4AR.mjs";
import {
  cyan
} from "./chunk-T3GWIVAM.mjs";
import {
  green
} from "./chunk-OR5PUD24.mjs";
import {
  pink
} from "./chunk-DCEG5LGX.mjs";
import {
  purple
} from "./chunk-L2OL7R23.mjs";
import {
  red
} from "./chunk-YZYGFPNK.mjs";
import {
  blue
} from "./chunk-GHZ36ATJ.mjs";

// src/colors/common.ts
var commonColors = {
  white: "#ffffff",
  black: "#000000",
  blue,
  green,
  pink,
  purple,
  red,
  yellow,
  cyan,
  zinc
};

export {
  commonColors
};
